import { AxiosError } from 'axios';
import arrayBufferParse from '../arrayBufferParse';
import { notification } from 'antd';
import notificationError from '../notificationError';

interface ErrorData {
  message: string;
  name: string;
  description: string;
  fieldErrors?: {
    EndDate?: string[];
  };
}

const reportNotificationError = (error: unknown) => {
  const erro = error as AxiosError<ErrorData>;
  const response = arrayBufferParse<ErrorData>(erro.response?.data);

  if (!!response?.fieldErrors?.EndDate?.length) {
    return notification.error({
      message: 'Erro na requisição',
      description: response.fieldErrors.EndDate[0],
    });
  }

  return notificationError(error);
};

export default reportNotificationError;
